import PackageCategoryCard from './PackageCategoryCard';

export default PackageCategoryCard;
